export default "__VITE_ASSET__DcWFt65e__"